import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Progress from "../Progress";

export default class UploadList extends React.Component
{
    static propTypes = {
        uploads: PropTypes.object.isRequired,
    };

    render()
    {
        return _.map(this.props.uploads, file => this.renderUpload(file))
    }

    renderUpload(upload)
    {
        if (upload.state === 'error')
        {
            return <div key={upload.id}>
                <span>{upload.filename}: Error!</span>
                <Progress error />
            </div>
        }

        return <div key={upload.id}>
            <span>{upload.filename}: {upload.percentage}%</span>
            <Progress percentage={upload.percentage} />
        </div>
    }

}
